module.exports = __webpack_public_path__ + "img/1441116426.d7e444d5.jpg";